// Audio utility for app sounds (splash, notifications, etc.)
class AppSounds {
  private audioContext: AudioContext | null = null;

  private getAudioContext(): AudioContext {
    if (!this.audioContext) {
      this.audioContext = new (window.AudioContext || (window as any).webkitAudioContext)();
    }
    return this.audioContext;
  }

  // Pleasant startup chime for splash screen
  playSplashSound(): void {
    try {
      const ctx = this.getAudioContext();
      
      // Create a magical chime sequence
      const playNote = (frequency: number, startTime: number, duration: number, volume: number) => {
        const oscillator = ctx.createOscillator();
        const gainNode = ctx.createGain();
        
        oscillator.connect(gainNode);
        gainNode.connect(ctx.destination);
        
        oscillator.type = 'sine';
        oscillator.frequency.setValueAtTime(frequency, ctx.currentTime + startTime);
        
        gainNode.gain.setValueAtTime(0, ctx.currentTime + startTime);
        gainNode.gain.linearRampToValueAtTime(volume, ctx.currentTime + startTime + 0.02);
        gainNode.gain.exponentialRampToValueAtTime(0.001, ctx.currentTime + startTime + duration);
        
        oscillator.start(ctx.currentTime + startTime);
        oscillator.stop(ctx.currentTime + startTime + duration);
      };

      // Emerald/magical chime - ascending notes (C5, E5, G5, C6)
      const notes = [523.25, 659.25, 783.99, 1046.50];
      notes.forEach((freq, i) => {
        playNote(freq, i * 0.1, 0.6 - i * 0.1, 0.15 - i * 0.02);
      });
      
      // Add a subtle shimmer overlay
      const shimmer = ctx.createOscillator();
      const shimmerGain = ctx.createGain();
      shimmer.connect(shimmerGain);
      shimmerGain.connect(ctx.destination);
      shimmer.type = 'triangle';
      shimmer.frequency.setValueAtTime(1568, ctx.currentTime + 0.3);
      shimmerGain.gain.setValueAtTime(0, ctx.currentTime + 0.3);
      shimmerGain.gain.linearRampToValueAtTime(0.05, ctx.currentTime + 0.35);
      shimmerGain.gain.exponentialRampToValueAtTime(0.001, ctx.currentTime + 0.8);
      shimmer.start(ctx.currentTime + 0.3);
      shimmer.stop(ctx.currentTime + 0.8);
      
    } catch (error) {
      console.debug('Audio not supported:', error);
    }
  }

  // Success sound for completing actions
  playSuccess(): void {
    try {
      const ctx = this.getAudioContext();
      
      const oscillator = ctx.createOscillator();
      const gainNode = ctx.createGain();
      
      oscillator.connect(gainNode);
      gainNode.connect(ctx.destination);
      
      oscillator.type = 'sine';
      oscillator.frequency.setValueAtTime(523.25, ctx.currentTime);
      oscillator.frequency.setValueAtTime(659.25, ctx.currentTime + 0.1);
      oscillator.frequency.setValueAtTime(783.99, ctx.currentTime + 0.2);
      
      gainNode.gain.setValueAtTime(0.2, ctx.currentTime);
      gainNode.gain.exponentialRampToValueAtTime(0.01, ctx.currentTime + 0.35);
      
      oscillator.start(ctx.currentTime);
      oscillator.stop(ctx.currentTime + 0.35);
    } catch (error) {
      console.debug('Audio not supported:', error);
    }
  }

  // Slide transition sound
  playSlide(): void {
    try {
      const ctx = this.getAudioContext();
      
      const oscillator = ctx.createOscillator();
      const gainNode = ctx.createGain();
      
      oscillator.connect(gainNode);
      gainNode.connect(ctx.destination);
      
      oscillator.type = 'sine';
      oscillator.frequency.setValueAtTime(400, ctx.currentTime);
      oscillator.frequency.exponentialRampToValueAtTime(600, ctx.currentTime + 0.08);
      
      gainNode.gain.setValueAtTime(0.1, ctx.currentTime);
      gainNode.gain.exponentialRampToValueAtTime(0.001, ctx.currentTime + 0.1);
      
      oscillator.start(ctx.currentTime);
      oscillator.stop(ctx.currentTime + 0.1);
    } catch (error) {
      console.debug('Audio not supported:', error);
    }
  }
}

export const appSounds = new AppSounds();
